import React from "react";

import {
  FiBox,
  FiFolder,
  FiGrid,
  FiPackage,
} from "react-icons/fi";

const DEFAULT_TABS = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: FiGrid,
  },
  {
    key: "categories",
    label: "Categories",
    icon: FiFolder,
  },
  {
    key: "products",
    label: "Products",
    icon: FiPackage,
  },
  {
    key: "stock",
    label: "Stock",
    icon: FiBox,
  },
];

const InventoryTabs = ({
  activeTab,
  onChange,
  tabs = DEFAULT_TABS,
  counts = {},
  disabled = false,
}) => {
  return (
    <div
      className="inventory-shared-tabs"
      role="tablist"
      aria-label="Inventory sections"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;

        const active =
          activeTab === tab.key;

        const count =
          counts?.[tab.key];

        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`inventory-shared-tab ${
              active ? "active" : ""
            }`}
            onClick={() => {
              if (
                typeof onChange ===
                "function"
              ) {
                onChange(tab.key);
              }
            }}
            disabled={
              disabled ||
              tab.disabled
            }
          >
            {Icon ? (
              <Icon />
            ) : null}

            <span>
              {tab.label}
            </span>

            {count !== undefined &&
            count !== null ? (
              <strong>
                {count}
              </strong>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default InventoryTabs;